import React from 'react';
import PropTypes from 'prop-types';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { Toast } from '@pearsontechnology/aero-components';
import { ToastItem } from './styles';

const ToastItems = ({ toasts, action, type }) => (
  <TransitionGroup>
    {
      toasts && toasts.map((toast) => (
        <CSSTransition key={`toast-${toast.id}`} in timeout={200} classNames={type}>
          {() => (
            <ToastItem data-testid="toastItem">
              <Toast
                message={toast.message}
                actions={toast.actions}
                onApplyAction={() => action(toast)}
                percentage={toast.percentage}
                subtitle={toast.subtitle}
              />
            </ToastItem>
          )}
        </CSSTransition>)
      )
    }
  </TransitionGroup>
);

ToastItems.propTypes = {
  toasts: PropTypes.array,
  action: PropTypes.func,
  type: PropTypes.string,
};

export default ToastItems;
